export const LINE_OPTS = {
    DEFAULT: {
        numbers: false,
        alphas: true,
        symbols: false
    }
}